import { useAuth } from "@/hooks/useAuth"

// ---------------------------------------------------------------------------
// useOwnerGate — client-side UI visibility gate for owner-only content.
// Extracted from src/pages/Reports.tsx (its €-sections used an inline
// `user?.email === OWNER_EMAIL` check). RLS still governs the underlying
// data; this only controls what renders.
// ---------------------------------------------------------------------------

const OWNER_EMAIL = "artem@teddykids.nl"

export function useOwnerGate(): { isOwner: boolean; isLoading: boolean } {
  const { user, loading } = useAuth()
  return { isOwner: user?.email === OWNER_EMAIL, isLoading: loading }
}
